import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class NavigationScrollService {
    private readonly damageListSegment = 'damages';
    private readonly damageListScrollYKey = 'damageListScrollY';
    private readonly damageListOrderIdKey = 'damageListOrderId';
    private readonly damageListDamageIdKey = 'damageListDamageId';

    constructor(private router: Router) {}

    public resetScrollPositionOnNavigation(url: string): void {
        if (this.shouldPreserveDamageListScrollPosition(url)) {
            return;
        }

        window.scrollTo(0, 0);
    }

    private shouldPreserveDamageListScrollPosition(url: string): boolean {
        return this.isDamageListRoute(url) && this.hasDamageListScrollRestoreState();
    }

    private isDamageListRoute(url: string): boolean {
        const primaryOutlet = this.router.parseUrl(url).root.children['primary'];
        const segments = primaryOutlet?.segments?.map(segment => segment.path) ?? [];
        const damagesIndex = segments.lastIndexOf(this.damageListSegment);

        if (damagesIndex < 0 || damagesIndex + 1 >= segments.length) {
            return false;
        }

        return segments.length - damagesIndex === 2;
    }

    private hasDamageListScrollRestoreState(): boolean {
        const state = window.history.state ?? {};
        const scrollY = Number(state[this.damageListScrollYKey]);
        const orderId = Number(state[this.damageListOrderIdKey]);
        const damageId = Number(state[this.damageListDamageIdKey]);

        return Number.isFinite(scrollY) && scrollY >= 0 && Number.isFinite(orderId) && orderId > 0 && Number.isFinite(damageId) && damageId > 0;
    }
}
